// Custom global scripts
jQuery(document).ready(function($) {
  'use strict';

  // Foundation Init
  $(document).foundation();

  $('.hp-hero').click(function() {
    if (window.innerWidth > 1023) {
      var expanedPanel = $('.hero-expanded');
      if (expanedPanel) {
        console.log("expanded panel");
        console.log(expanedPanel);
        expanedPanel.removeClass("large-6");
        expanedPanel.removeClass("hero-expanded");
        expanedPanel.addClass("auto");
        expanedPanel.find('.hp-hero__heading-only--overlay').removeClass('hp-hero__heading-only--overlay-half');
        expanedPanel.find('.hp-hero__heading-text').hide();
        expanedPanel.find('.hp-hero__heading-only').show();
      }
      $(this).removeClass('auto');
      $(this).addClass('large-6');
      $(this).addClass('hero-expanded');
      $(this).find('.hp-hero__heading-only--overlay').addClass('hp-hero__heading-only--overlay-half');
      $(this).find('.hp-hero__heading-only').hide();
      $(this).find('.hp-hero__heading-text').show();
  }
  });

  if ($("#popup").length && !localStorage.getItem("popup")) {
    setTimeout(function () {
      $("#popup").foundation("open");
      localStorage.setItem("popup", "opened");
    }, 2000);
  }

   //Counter
   const counter = document.getElementById("counter");

   if (counter) {
     var a = 0;
     $(window).scroll(function () {
       var oTop = $("#counter").offset().top - window.innerHeight;
       if (a == 0 && $(window).scrollTop() > oTop) {
         $(".counter-value").each(function () {
           var $this = $(this),
             countTo = $this.attr("data-count");
           $({
             countNum: $this.text(),
           }).animate(
             {
               countNum: countTo,
             },
 
             {
               duration: 3600,
               easing: "swing",
               step: function () {
                 $this.text(Math.floor(this.countNum));
               },
               complete: function () {
                 $this.text(this.countNum);
                 //alert('finished');
               },
             }
           );
         });
         a = 1;
       }
     });
   }


/*
  $('.hp-hero').hover(function() {
    $(this).removeClass('auto');
    $(this).addClass('large-7');
    $(this).find('.hp-hero__heading-only').hide();
    $(this).find('.hp-hero__heading-text').show();
}, function() {
    $(this).removeClass('large-7');
    $(this).addClass('auto');
    $(this).find('.hp-hero__heading-text').hide();
    $(this).find('.hp-hero__heading-only').show();
});
*/
}(jQuery));
